import moment from "moment";
import {
  CREATE_DAYS_IN_MONTH,
  SELECTED_DATE,
  SELECTED_MONTH,
  REQUEST_SPECIALIST_BY_HOSPITAL,
  REQUEST_SPECIALIST_BY_HOSPITAL_SUCCESS,
  SELECTED_SPECIALIST,
  HIDE_MODAL_CONFIRM_SELECTED_SPECIALIST,
  HIDE_MODAL_FILTER_SPECIALIST,
  SET_SEARCH_PATTERN,
  ADD_SPECIALIST_MORE,
  FILL_BY_FOLLOWUP,
  RESET_ALL_PROPS_DATE_AND_SPECIALIST,
  HIDE_ALERT_INVALID_YEAR_WITH_SPECIALTITY,
  SHOW_ALERT_INVALID_YEAR_WITH_SPECIALTITY,
  SHOW_ALERT_HOLIDAY_MODAL,
  HIDE_ALERT_HOLIDAY_MODAL,
  SHOW_ALERT_GUIDE_LINE_MODAL,
  HIDE_ALERT_GUIDE_LINE_MODAL,
  SELECTED_CALENDAR_SHOW_ONE_ROW,
  RESET_SHOW_ONE_ROW,
  // SHOW_LIST_SPECIALIST_INLINE,
  HIDE_LIST_SPECIALIST_INLINE,
  CLOSE_TO_CHOOSE_CALENDAR_AGAIN,
  RESET_SELECT_DATE_AND_SPECIALIST,
  RESET_ADD_MORE_SPECIALIST,
  RESET_SELECT_DATE
} from "~/store/dateAndSpecialist/dateAndSpecialistTypes";
import { renderCalendar, createMonthList } from "~/utils/calendar";
import { chunk } from "lodash";
const initialState = {
  loading: false,
  selectedDate: undefined,
  days: [],
  months: [],
  // currentDate: moment(),
  selectedMonth: moment(),
  allSpecialist: [],
  selectedSpecialist: {},
  showSelectedSpecialist: false,
  showGuideLineModal: false,
  isModal: false,
  searchPattern: "",
  alertHolidayModal: false,
  errors: {},
  allServices: [],
  selectedService: {},
  selectedShowOnRow: false,
  showListSpecialistInline: false,
  isMoreSpecialist: false,
  isShowAlertErrorInvalidYearWithSpeciality: false,
  messageErrorInvalidYearWithSpeciality: ""
};

export default function dateAndSpecialist(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_DAYS_IN_MONTH: {
      const selectedMonth = action.selectedMonth;
      // const currentDate = action.currentDate;
      const days = renderCalendar(selectedMonth);
      const months = createMonthList(selectedMonth);
      // const chunkArray = chunk(days, 7);
      // const lastItem = last(chunkArray);
      // const findIndexCurrentDate = findIndex(lastItem, function(item) {
      //   const formatItem = moment(item);
      //   return currentDate.isSame(formatItem, 'day');
      // });
      // if (findIndexCurrentDate === 6) {
      //   selectedMonth = months[1];
      //   days = renderCalendar(selectedMonth);
      // }
      // if (findIndexCurrentDate >= 0) {
      //   selectedMonth = months[1];
      //   days = renderCalendar(selectedMonth);
      // }
      return {
        ...state,
        days: [...days],
        months: [...months],
        selectedMonth
      };
    }
    case SELECTED_DATE: {
      /* render lai days */
      const { selectedShowOnRow } = state;
      if (selectedShowOnRow) {
        const { days } = state;
        const chunkArray = chunk(days, 7);
        const filter = chunkArray.filter(item => {
          const filterDay = item.find(d => {
            const check = moment(d).isSame(action.date, "day");
            return check;
          });
          if (typeof filterDay !== typeof undefined) {
            return item;
          }
          return null;
        });
        const dayReturn = filter ? filter[0] : [];
        return {
          ...state,
          selectedDate: action.date,
          days: dayReturn,
          showListSpecialistInline: true
        };
      } else {
        return {
          ...state,
          selectedDate: action.date
        };
      }
    }

    case SELECTED_MONTH: {
      const selectedMonthNextPrev = action.month;
      const daysInChangeMonth = renderCalendar(selectedMonthNextPrev);
      return {
        ...state,
        selectedMonth: selectedMonthNextPrev,
        days: [...daysInChangeMonth]
      };
    }
    case REQUEST_SPECIALIST_BY_HOSPITAL:
      return {
        ...state,
        loading: true
      };
    case REQUEST_SPECIALIST_BY_HOSPITAL_SUCCESS:
      return {
        ...state,
        allSpecialist: [...action.data],
        loading: false
      };
    case SELECTED_SPECIALIST:
      return {
        ...state,
        selectedSpecialist: { ...action.specialist },
        showSelectedSpecialist: true
      };
    case HIDE_MODAL_CONFIRM_SELECTED_SPECIALIST:
      return {
        ...state,
        showSelectedSpecialist: false
      };
    case HIDE_MODAL_FILTER_SPECIALIST:
      return {
        ...state,
        isModal: false,
        searchPattern: ""
      };
    case SET_SEARCH_PATTERN:
      return {
        ...state,
        searchPattern: action.pattern
      };
    case ADD_SPECIALIST_MORE: {
      const { days } = state;
      const chunkArray = chunk(days, 7);
      const filter = chunkArray.filter(item => {
        const filterDay = item.find(d => {
          const check = moment(d).isSame(action.date, "day");
          return check;
        });
        if (typeof filterDay !== typeof undefined) {
          return item;
        }
        return null;
      });
      const dayReturn = filter ? filter[0] : [];
      return {
        ...state,
        showSelectedSpecialist: false,
        selectedSpecialist: {},
        isModal: true,
        searchPattern: "",
        isMoreSpecialist: true,
        //
        days: dayReturn,
        showListSpecialistInline: true,
        selectedDate: action.date
      };
    }

    case RESET_ADD_MORE_SPECIALIST:
      return {
        ...state,
        isMoreSpecialist: false,
        showListSpecialistInline: false
      };

    case FILL_BY_FOLLOWUP:
      return {
        ...state,
        isModal: true,
        selectedDate: action.data.selectedDate,
        selectedMonth: action.data.selectedMonth,
        selectedSpecialist: action.data.selectedSpecialist
      };
    case RESET_ALL_PROPS_DATE_AND_SPECIALIST:
      return {
        ...state,
        ...initialState
      };

    case RESET_SELECT_DATE_AND_SPECIALIST:
      return {
        ...state,
        selectedDate: undefined,
        selectedSpecialist: {}
      };

    case RESET_SELECT_DATE:
      return {
        ...state,
        selectedDate: undefined
      };

    case HIDE_ALERT_INVALID_YEAR_WITH_SPECIALTITY:
      return {
        ...state,
        isShowAlertErrorInvalidYearWithSpeciality: false,
        messageErrorInvalidYearWithSpeciality: ""
      };
    case SHOW_ALERT_INVALID_YEAR_WITH_SPECIALTITY:
      return {
        ...state,
        isShowAlertErrorInvalidYearWithSpeciality: true,
        messageErrorInvalidYearWithSpeciality: action.message
      };

    case SHOW_ALERT_HOLIDAY_MODAL:
      return {
        ...state,
        alertHolidayModal: true
      };
    case HIDE_ALERT_HOLIDAY_MODAL:
      return {
        ...state,
        alertHolidayModal: false
      };
    case SHOW_ALERT_GUIDE_LINE_MODAL:
      return {
        ...state,
        showGuideLineModal: true
      };
    case HIDE_ALERT_GUIDE_LINE_MODAL:
      return {
        ...state,
        showGuideLineModal: false
      };
    case SELECTED_CALENDAR_SHOW_ONE_ROW:
      return {
        ...state,
        selectedShowOnRow: true
      };
    case RESET_SHOW_ONE_ROW:
      return {
        ...state,
        selectedShowOnRow: false
      };
    case CLOSE_TO_CHOOSE_CALENDAR_AGAIN: {
      const { selectedMonth } = state;
      const daysInChangeMonth = renderCalendar(selectedMonth);
      return {
        ...state,
        showListSpecialistInline: false,
        selectedDate: undefined,
        // selectedSpecialist: {},
        days: [...daysInChangeMonth]
      };
    }
    case HIDE_LIST_SPECIALIST_INLINE:
      return {
        ...state,
        showListSpecialistInline: false
      };

    default:
      return state;
  }
}
